'use client';

import { useAtomValue } from 'jotai/index';

import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import {
  GeoBboxNames,
  PaginationNames,
} from '@/features/listing/types/listing-filters-types';
import { type ListingsCollection } from '@/features/listing/types/listing-types';
import Pagination from '@/ui/pagination/pagination';

interface ListingsPaginationProps {
  listingsCount: ListingsCollection['count'];
  listingsPerPage: number;
  searchGeoBbox?: ListingsCollection['searchGeoBbox'];
}

export default function ListingsPagination(props: ListingsPaginationProps) {
  const {
    listingsCount,
    listingsPerPage,
    searchGeoBbox,
  } = props;

  const isMapView = useAtomValue(isMapViewAtom);

  return isMapView ? null : (
    <Pagination
      itemsCount={listingsCount}
      itemsPerPage={listingsPerPage}
      pageNumberParamName={PaginationNames.PageNumber}
      fallbackSearchParams={searchGeoBbox ? {
        [GeoBboxNames.LatitudeSouthWest]: String(searchGeoBbox.latitudeSouthWest),
        [GeoBboxNames.LongitudeSouthWest]: String(searchGeoBbox.longitudeSouthWest),
        [GeoBboxNames.LatitudeNorthEast]: String(searchGeoBbox.latitudeNorthEast),
        [GeoBboxNames.LongitudeNorthEast]: String(searchGeoBbox.longitudeNorthEast),
      } : undefined}
    />
  );
}
